/* HH6 reviews: re-renders the Judge.me featured carousel (real reviews read from its DOM). Original widget stays in DOM, visually hidden. */
(function () {
  var root = null;
  function ensureRoot() {
    if (root) return root;
    var w = document.querySelector('.jdgm-carousel-wrapper'), sec = w && w.closest('.shopify-section');
    if (!sec) return null;
    root = document.createElement('section');
    root.className = 'hh6r'; root.hidden = true; root.setAttribute('aria-label', 'Customer reviews');
    sec.parentNode.insertBefore(root, sec.nextSibling);
    return root;
  }
  var ALL = 'https://app.judge.me/reviews/stores/hobbyisthaven.com';
  var MON = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  /* privacy: never show an email / handle; first name + last initial otherwise */
  function niceName(raw) {
    var n = (raw || '').replace(/\s+/g, ' ').trim();
    if (!n || /@|\d|\bcom\b/i.test(n)) return 'Verified buyer';
    var p = n.split(' ');
    if (p.length === 1) return p[0];
    var last = p[p.length - 1];
    return p[0] + ' ' + last.charAt(0).toUpperCase() + '.';
  }
  function niceDate(s) {
    var m = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(s || '');
    return m ? MON[+m[1] - 1] + ' ' + m[3] : '';
  }
  var star = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M10 1.6l2.5 5.4 5.9.7-4.4 4 1.2 5.8L10 14.6l-5.2 2.9L6 11.7 1.6 7.7l5.9-.7z"/></svg>';
  function stars(n, cls) {
    var h = '';
    for (var i = 1; i <= 5; i++) {
      var f = Math.max(0, Math.min(1, n - (i - 1)));
      h += '<i style="--f:' + Math.round(f * 100) + '%">' + star + '</i>';
    }
    return '<span class="hh6r-stars ' + (cls || '') + '" role="img" aria-label="' + (Math.round(n * 10) / 10) + ' out of 5 stars">' + h + '</span>';
  }
  var tries = 0;
  function read() {
    var w = document.querySelector('.jdgm-carousel-wrapper');
    if (!w) return null;
    var sc = w.querySelector('.jdgm-all-reviews-rating[data-score]');
    var nc = w.querySelector('[data-number-of-reviews]');
    var score = sc ? parseFloat(sc.dataset.score) : 0;
    var count = nc ? parseInt(nc.dataset.numberOfReviews, 10) : 0;
    var seen = {}, items = [];
    w.querySelectorAll('.jdgm-carousel-item').forEach(function (el) {
      var id = el.dataset.reviewId || el.textContent;
      if (seen[id]) return; seen[id] = 1;
      var q = function (s) { var e = el.querySelector(s); return e ? e.textContent.replace(/\s+/g, ' ').trim() : ''; };
      var body = q('.jdgm-carousel-item__review-body');
      if (!body) return;
      var ts = el.querySelector('.jdgm-carousel-item__timestamp');
      items.push({
        rating: el.querySelectorAll('.jdgm-carousel-item__review-rating .jdgm--on').length || 5,
        title: q('.jdgm-carousel-item__review-title'),
        body: body,
        name: q('.jdgm-carousel-item__reviewer-name'),
        date: ts ? (ts.dataset.time || '') : '',
        product: q('.jdgm-carousel-item__product-title')
      });
    });
    var ver = true; /* owner asked for the Verified buyer label; Judge.me exposes no per-review flag */
    var sec = w.closest('.shopify-section');
    return { score: score, count: count, items: items, ver: ver, sec: sec };
  }
  function build(d) {
    var avg = (Math.round(d.score * 10) / 10).toFixed(1);
    var cnt = d.count.toLocaleString('en-US');
    var check = '<svg viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="10" r="9"/><path d="M5.8 10.4l2.8 2.8 5.6-5.8" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var cards = d.items.map(function (r) {
      var nm = niceName(r.name), dt = niceDate(r.date);
      return '<article class="hh6r-card">' + stars(r.rating) +
        (r.title ? '<h3 class="hh6r-t">' + esc(r.title) + '</h3>' : '') +
        '<div class="hh6r-q"><p>' + esc(r.body) + '</p></div>' +
        '<button type="button" class="hh6r-more" hidden aria-expanded="false">Read more</button>' +
        (r.product ? '<div class="hh6r-p">' + esc(r.product) + '</div>' : '') +
        '<footer class="hh6r-f"><b>' + esc(nm) + '</b><span class="hh6r-v">' +
        (d.ver ? check + 'Verified buyer' : '') + (dt ? '<em>' + dt + '</em>' : '') + '</span></footer></article>';
    }).join('');
    root.innerHTML =
      '<div class="hh6r-in"><aside class="hh6r-sum"><h2>Customer Reviews</h2><p class="hh6r-sub">Trusted by modelers worldwide.</p>' +
      '<div class="hh6r-big"><b>' + avg + '</b><span>/5</span></div>' + stars(d.score, 'hh6r-lg') +
      '<p class="hh6r-cnt">From ' + cnt + ' reviews</p>' +
      '<a class="hh6r-all" href="' + ALL + '" target="_blank" rel="noopener">See all reviews <span aria-hidden="true">&rarr;</span></a></aside>' +
      '<div class="hh6r-car"><button type="button" class="hh6r-ar hh6r-prev" aria-label="Previous reviews"><svg viewBox="0 0 20 20"><path d="M12.5 4l-6 6 6 6" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
      '<div class="hh6r-track" tabindex="0" role="region" aria-label="Customer reviews, scroll sideways">' + cards + '</div>' +
      '<button type="button" class="hh6r-ar hh6r-next" aria-label="Next reviews"><svg viewBox="0 0 20 20"><path d="M7.5 4l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
      '<div class="hh6r-dots" aria-hidden="true"></div></div></div>';
    var tr = root.querySelector('.hh6r-track'), prev = root.querySelector('.hh6r-prev'), next = root.querySelector('.hh6r-next'), dots = root.querySelector('.hh6r-dots');
    function step() { var c = tr.querySelector('.hh6r-card'); return c ? c.getBoundingClientRect().width + 16 : 300; }
    function upd() {
      var max = tr.scrollWidth - tr.clientWidth - 2;
      prev.disabled = tr.scrollLeft <= 2; next.disabled = tr.scrollLeft >= max;
      var pages = Math.max(1, Math.round(tr.scrollWidth / step() - tr.clientWidth / step() + 1)), cur = Math.round(tr.scrollLeft / step());
      if (dots.children.length !== pages) { dots.innerHTML = new Array(pages + 1).join('<i></i>'); }
      for (var i = 0; i < dots.children.length; i++) dots.children[i].className = i === cur ? 'on' : '';
    }
    prev.onclick = function () { tr.scrollBy({ left: -step() * (window.innerWidth > 900 ? 3 : 1), behavior: 'smooth' }); };
    next.onclick = function () { tr.scrollBy({ left: step() * (window.innerWidth > 900 ? 3 : 1), behavior: 'smooth' }); };
    tr.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
    tr.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') next.click(); if (e.key === 'ArrowLeft') prev.click(); });
    function clampCheck() {
      root.querySelectorAll('.hh6r-card').forEach(function (c) {
        var q = c.querySelector('.hh6r-q'), b = c.querySelector('.hh6r-more');
        if (c.classList.contains('open')) return;
        b.hidden = !(q.scrollHeight > q.clientHeight + 2);
      });
    }
    root.querySelectorAll('.hh6r-more').forEach(function (b) {
      b.onclick = function () { var c = b.closest('.hh6r-card'), o = c.classList.toggle('open'); b.textContent = o ? 'Show less' : 'Read more'; b.setAttribute('aria-expanded', o); };
    });
    root.hidden = false; root.setAttribute('data-hh6r-done', '1');
    if (d.sec) d.sec.classList.add('hh6r-replaced');
    document.documentElement.classList.add('hh6r-on');
    clampCheck(); upd();
    window.addEventListener('resize', function () { clampCheck(); upd(); });
  }
  function go() {
    if (document.querySelector('[data-hh6r-done]')) return true;
    var d = read();
    if (d && !ensureRoot()) return false;
    if (d && d.items.length && d.score > 0 && d.count > 0) { try { build(d); } catch (e) { root.hidden = true; document.documentElement.classList.remove('hh6r-on'); if (d.sec) d.sec.classList.remove('hh6r-replaced'); if (window.console) console.warn('hh6r', e); } return true; }
    return false;
  }
  function wait() {
    if (go()) return;
    if (++tries > 40) return;
    setTimeout(wait, 500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wait); else wait();
})();
